import React from "react";
import "./styles.scss";
import { FormCheck } from "..";

const Index = ({ data, onClick }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div
        className={`keyword-checkBox-wrapper ${
          data.isSelect ? "active-me" : ""
        }`}
        onClick={onClick}
      >
        <FormCheck
          data={{
            isSelect: data?.isSelect,
            iconName: "check",
            type: "round",
          }}
          onClick={onClick}
        />
        <div className="kcw__checkName">{data?.keyword}</div>
      </div>
    </>
  );

  return <>{inputElement}</>;
};

Index.propTypes = {};

Index.defaultProps = {};

export default Index;
